import { Alert } from 'omakase';
import { IconClock, IconPeopleTeam } from '@tock/icons';
import { IconClock as IconClockLegacy, IconPeople } from 'ui/icons';
import { IconMigrationUtil } from 'omakase/utils/IconMigrationUtil';
import { LoadingContainer } from 'ui';
import { useFeatureFlag } from '@tock/shared/utils/featureFlagContext';
import { walkinWaitlistAlertRoot } from 'components/business/walkin-waitlist/walkinWaitlistCssDefs';
import React from 'react';
import pluralize from 'pluralize';

interface Props {
  onWaitlist: boolean;
  numPartiesAhead: number;
  isNumPartiesAheadLoading?: boolean;
}

const WalkinWaitlistAlertStatus: React.FunctionComponent<Props> = ({
  onWaitlist,
  numPartiesAhead,
  isNumPartiesAheadLoading = false,
}) => {
  const alertIcon = onWaitlist ? (
    <IconMigrationUtil legacyIcon={<IconClockLegacy />} newIcon={<IconClock />} />
  ) : (
    <IconMigrationUtil legacyIcon={<IconPeople />} newIcon={<IconPeopleTeam />} />
  );
  const waitlistPositionEnabled = useFeatureFlag('ONLINE_WALKIN_WAITLIST_POSITION');

  const statusMessage =
    onWaitlist && numPartiesAhead === 0
      ? "You're first in line"
      : `There ${pluralize('is', numPartiesAhead, false)} ${pluralize(
          'party',
          numPartiesAhead,
          true
        )} ahead in line`;

  return numPartiesAhead > -1 && waitlistPositionEnabled ? (
    <Alert icon={alertIcon} severity="info" css={walkinWaitlistAlertRoot}>
      <LoadingContainer loading={isNumPartiesAheadLoading}>{statusMessage}</LoadingContainer>
    </Alert>
  ) : null;
};

export default WalkinWaitlistAlertStatus;
